import React from 'react';
import { X, Swords } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import TieFormatToggle from './TieFormatToggle';
import TeamPairingConfig from './TeamPairingConfig';
import { TIE_FORMATS, collectEligibleTeams } from '../generators/tieFormats';

/**
 * MLP tie-format configuration, in a modal rather than inline in the
 * generated schedule — the Single-match/MLP-Slate toggle plus (once MLP
 * Slate is selected) the per-team gender + pairing editor. Only ever opened
 * from GeneratedScheduleStep.jsx's "MLP Settings" trigger, which itself only
 * renders when the schedule actually has eligible ties (see
 * tieFormats.hasEligibleTies) — this component doesn't re-check that, it
 * just assumes it was opened for a reason.
 */
const MLPSettingsModal = ({ isOpen, onClose, roundsArrays, tieFormat, onTieFormatChange, tieOverrides, onTieOverridesChange }) => {
  const { theme } = useTheme();
  if (!isOpen) return null;

  const teams = collectEligibleTeams(roundsArrays);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative flex max-h-[90vh] w-full max-w-2xl flex-col rounded-2xl border ${theme.border} ${theme.card} ${theme.shadow}`}>
        <div className={`flex shrink-0 items-center justify-between border-b ${theme.border} px-6 py-4`}>
          <div className={`flex items-center gap-2 text-base font-bold ${theme.text}`}>
            <Swords size={18} />
            MLP Settings
          </div>
          <button
            type="button"
            onClick={onClose}
            className={`flex h-8 w-8 items-center justify-center rounded-lg transition-colors ${theme.buttonGhost}`}
          >
            <X size={16} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <TieFormatToggle value={tieFormat} onChange={onTieFormatChange} />
          {tieFormat === TIE_FORMATS.MLP_SLATE && (
            <TeamPairingConfig
              teams={teams}
              overrides={tieOverrides}
              onApply={(overrides) => {
                onTieOverridesChange(overrides);
                onClose();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MLPSettingsModal;
